import axios from 'axios';
import Store from '../store/index';
import Router from '../router/index';
import CONST from '../config';
import SR from './sign';
const Notification = () => {};
/**
 * @description 获取当前页面路径
 */
const getCurrentPage = () => {
  return window.location.href;
};

/**
 * @description 提示弹窗
 * @param msg
 * @param code
 */
const errorShow = (code, msg) => {
  Notification({ type: 'warning', title: code, message: msg });
};

/**
 * @param res
 * @description 请求失败后的错误统一处理
 */
const errorHandle = res => {
  // 状态码判断
  const status = res.code;
  switch (status) {
    case '99001': // 99001: 签名验证失败，签名过期
      errorShow(status, '签名验证失败');
      break;
    case '99002': // 99002: 参数错误,参数缺失
      errorShow(status, res.msg);
      break;
    case '40101': // 40101 token过期, 清除token并跳转授权页重新授权
      errorShow(status, '登录超时，请重新登录');
      if (Router.currentRoute.path !== '/login') {
        Router.replace('/login');
      }
      break;
    default:
      errorShow(status, res.msg);
  }
};

const instance = axios.create({ timeout: 100000, baseURL: CONST.$BASE_URL });

// 请求拦截
instance.interceptors.request.use(
  config => {
    config.headers.clientId = CONST.$CLIENT_ID;
    // config.headers.sourceType = Store.getters.env;
    config.headers['User-Source'] = CONST.$USER_SOURCE;
    config.headers.requestPage = getCurrentPage();
    if (Store.state.token) {
      config.headers.token = Store.state.token; // 让每个请求携带token
    }
    return config;
  },
  error => {
    console.error('请求错误：', error);
    Promise.reject(error);
  }
);

// 响应拦截
instance.interceptors.response.use(
  response => {
    const data = response.data;
    if (data.code !== CONST.$CODE) {
      // 数据错误逻辑
      errorHandle(data);
    }
    return Promise.resolve(data);
  },
  error => {
    const { response } = error;
    // http请求错误
    // 请求已发出，但是不在2xx的范围
    // errorHandle(response.status, response.data.message)
    if (response) {
      if (response.status === 404) {
        errorShow(response.status, '404,地址不存在');
      } else if (response.status === 401) {
        errorShow(response.status, '没有访问权限');
      } else if (response.status === 403) {
        errorShow(response.status, '拒绝访问');
      } else {
        errorShow(response.status, '服务异常，请联系管理员');
      }
    }
    console.error('http错误---：', error);
    return Promise.resolve(error);
  }
);

/**
 * @description 图片文件上传
 * @return {Promise}
 */
export function FilePost (ossHost, ossData) {
  return instance.post(ossHost, ossData, { headers: { 'Content-Type': 'multipart/form-data' } });
}

/**
 * @description Post请求
 * @return {Promise}
 */
export function Post (url, params) {
  return instance.post(url, SR(params));
}

/**
 * @description Put请求
 * @return {Promise}
 */
export function Put (url, params) {
  return instance.put(url, SR(params));
}

/**
 * @description Get请求
 * @return {Promise}
 */
export function Get (url, params) {
  return instance.get(url, { params: SR(params) });
}

/**
 * @description 高德轨迹点请求Get请求
 * @return {Promise}
 */
export function mapGet (url, params) {
  return instance.get(url, { params, baseURL: '/amap' });
}

/**
 * @description Delete请求
 * @return {Promise}
 */
export function Delete (url, params) {
  return instance.delete(url, { params: SR(params) });
}
